export default __webpack_public_path__ + "static/hero-background-eb9b76efc87994c17c74332723bb9c3e.jpg";